import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { PayFileListPage } from "@/screens/Accounting/subfeatures/PayFiles"
import { payFileSearchParamsSchema } from "@/screens/Accounting/subfeatures/PayFiles/types/searchParams"

// No `retainSearchParams`: the sibling Payable Approvals tab also carries `field`/`order`, but with
// InvoiceSortField values. Retaining them here would let each tab's sort bleed into the other, where
// the schema fallback silently rewrites it and the user's sort is lost. The fallback already
// supplies CREATED_ON/DESC on first load.
export const Route = createFileRoute("/app/accounting/_layout/huntington-pay-files")({
  validateSearch: zodValidator(payFileSearchParamsSchema),
  component: () => (
    <PermissionContentWrapper permissions={[PermissionActionType.PAY_FILE]}>
      <PayFileListPage />
    </PermissionContentWrapper>
  ),
})
